import React from "react";
import "./sideNav.css";
import { useNavigate, useLocation } from "react-router-dom";
import { SideDrawerItem } from "@nokia-csf-uxr/ccfk/SideDrawer";
import UserSettingsIcon from "@nokia-csf-uxr/ccfk-assets/icons/latest/user-settings.svg";
import marketplaceCartIcon from "../Assets/Icons/marketplace_cart_icon.svg";
import CalendarIcon from "@nokia-csf-uxr/ccfk-assets/icons/latest/calendar.svg";
import quotationIcon from "../Assets/Icons/quotations_icon.svg";
import adminIcon from '../Assets/Icons/user_icon.svg';
import ordersIcon from '../Assets/Icons/orders_icon.svg';
import { resetPaginationsProps } from "Store/contentState/paginationSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "Store/mainStore";
import { clearGlobalSearchText,resetColumnFilter } from "Store/contentState/commonSlice";
import { setProp } from "Store/Actions";
import DashboardIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/dashboard.svg';
import matrix from '../Assets/Icons/matrix.png'
import CIQIcon from '../Assets/Icons/CIQ.png'
import PerCIQIcon from '../Assets/Icons/PreCIQ.png'
import { Tooltip } from "@nokia-csf-uxr/ccfk";
import { replaceUnderscoreWithSpace } from "Pages/admin/user-management/utils/constants";
import networkMasterIcon from "../Assets/Icons/network-master-icon.svg";
import rolesIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/rule.svg';
import merchantOrderIcon from '../Assets/Icons/merchant_order_icon.svg';
import stockInventoryIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/module.svg';
import profitabilityIcon from '../Assets/Icons/profitability.svg'
import DOTOfferIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/legend.svg';
import CheckListIcon from '@nokia-csf-uxr/ccfk-assets/latest/CheckListIcon';
import LikeIcon from '@nokia-csf-uxr/ccfk-assets/latest/LikeIcon';
import onboardingIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/user-assign-rtl.svg'
import salesIntelligenceIcon from '../Assets/Icons/portfolio-icon.svg'
import aiIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/chat.svg';
import PolicyCheckIcon from '@nokia-csf-uxr/ccfk-assets/icons/latest/policy-check.svg';
import InstalledBaseIcon from '../Assets/Icons/installed_base_icon.svg';
import FileAssets from '../Assets/Icons/fileAssets.svg';


// Before: if (navItem === 'orders' || navItem === 'merchant_orders' || ...)
// After: if (EXCLUDED_ITEMS.includes(navItem)) return null;
// Route mapping:

// Before: /${navItem === 'common_orders' ? "orders" : navItem === 'common_products' ? "products" : ...}
// (no-op)
// Items to exclude from rendering


// Items to exclude from rendering in the side navigation. Removed frame_agreement,
// esign and agreement_template so they appear as tabs alongside Contract Hub.
// Exclude items that should not appear as individual side-nav entries.
// Note: `frame_agreement`, `esign`, and `agreement_template` are excluded
// so the single `contract` nav entry is shown instead and the Contracts
// page is responsible for rendering tabs for those sub-apps.
export const EXCLUDED_ITEMS = ['orders', 'merchant_orders', 'products', 'nokia_products', 'user_onboarding', 'onboarding_registration', 'frame_agreement', 'esign', 'agreement_template', 'quotations', 'ciq'];

// Route mappings
const ROUTE_MAPPINGS = {
  'common_orders': 'orders',
  'common_products': 'products',
  'common_contracts': 'contract',
  'onboarding': 'user_onboarding',
  business_hub: 'deal_registration',
  deal_registration: 'deal_registration',
};

const getExternalAppUrl = (navItem, applicationConfigMapping = {}) => {
  const appConfig = applicationConfigMapping?.[navItem];

  if (appConfig?.integration_type === 'App' && appConfig?.application_url) {
    return appConfig.application_url;
  }

  return null;
};

const getIcon = (navItem) => {
  switch (navItem) {
    case 'marketplace':
      return marketplaceCartIcon;
    case 'quotations':
      return quotationIcon;
    case 'orders':
      return ordersIcon;
    case 'subscription':
      return CalendarIcon;
    case 'account':
      return UserSettingsIcon;
    case 'users':
      return adminIcon;
    case 'roles':
      return rolesIcon;
    case 'dashboard':
      return DashboardIcon;
    case 'products':
      return matrix;
    case 'common_products':
      return matrix;
    case 'radio_network_ciq':
      return CIQIcon
    case 'ciq':
      return PerCIQIcon
    case 'networks':
      return networkMasterIcon;
    case 'common_orders':
      return merchantOrderIcon;
    case 'stock_inventory':
      return stockInventoryIcon;
    // Added profitability icon
    case 'pricing':
      return profitabilityIcon;
    case 'tasks':
      return CheckListIcon;
    case 'offer':
      return DOTOfferIcon;
    case 'ask-business-platform':
      return aiIcon;
    case 'contract':
      return PolicyCheckIcon;
    case 'onboarding':
      return onboardingIcon;
    case 'installed_base':
      return InstalledBaseIcon;
    case 'sales_intelligence':
      return salesIntelligenceIcon;
    case 'assets':
      return FileAssets;
    case 'deal_registration':
    case 'business_hub':
      return LikeIcon;
    default:
      return null; // Return a default icon or null if no match is found
  }
};

export const getRouteForNavItem = (navItem) => ROUTE_MAPPINGS[navItem] || navItem;

const LoadNavLinks = (navItemOrProps) => {
  const isString = typeof navItemOrProps === 'string';
  const navItem = isString ? navItemOrProps : navItemOrProps?.navItem;
  const groupItem = isString ? false : !!navItemOrProps?.groupItem;
  const orderIndex = isString ? undefined : navItemOrProps?.orderIndex;
  const firstGroupItem = isString ? false : !!navItemOrProps?.firstGroupItem;
  const lastGroupItem = isString ? false : !!navItemOrProps?.lastGroupItem;
  const groupHeaderHasIcon = isString ? false : !!navItemOrProps?.groupHeaderHasIcon;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const globalSearchText = useSelector((state: RootState) => state.common.globalSearchText);
  const sidBarToggleState = useSelector((state: RootState) => state.common.sideBarOpen);
  const applicationNameMappingList = useSelector((state: RootState) =>  state.userManagement.metaData.applicationListNameMapping)
  const applicationConfigMapping = useSelector((state: RootState) => state.userManagement.metaData.applicationConfigMapping);
  const marketplacePartnerList = useSelector((state: RootState) => state.marketplace);
  
  
  // if (navItem === 'orders' || navItem === 'merchant_orders' || navItem === 'products' || navItem === 'nokia_products' || navItem === 'frame_agreement' || navItem === 'esign' || navItem === 'agreement_template') return null;
  if (!navItem || EXCLUDED_ITEMS.includes(navItem)) return null;
  
  const handleTabCommonPropsReset = () => {
    // Check if the clicked navItem is one of the ones you want to trigger resetPaginationProps for
    if (globalSearchText) {
      dispatch(clearGlobalSearchText())
    }
    if (navItem === 'marketplace' || navItem === 'users' || navItem === 'networks' || navItem === "products" || navItem === "orders" || navItem === "quotations") {
      dispatch(resetPaginationsProps()); // Dispatch resetPaginationProps action
    }
    dispatch(resetColumnFilter()); // Reset column filters
  }

  // Override display label for onboarding-related keys to 'Onboarding'
  const onboardingKeys = ['user_onboarding', 'onboarding', 'onboarding_registration'];
  const rawLabel = applicationNameMappingList[navItem] || replaceUnderscoreWithSpace(navItem.charAt(0).toUpperCase() + navItem.slice(1));
  const label = onboardingKeys.includes(navItem) ? 'Onboarding' : rawLabel;
  const externalUrl = getExternalAppUrl(navItem, applicationConfigMapping);

  if (externalUrl) {
    const handleExternalAppClick = () => {
      handleTabCommonPropsReset();
    };

    const externalNavItem = (
      <SideDrawerItem
        icon={<img alt={`Icon ${navItem}`} src={getIcon(navItem)} />}
        label={label}
        selected={false}
      />
    );

    return (
      <a
        key={navItem}
        href={externalUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleExternalAppClick}
        style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
      >
        {!sidBarToggleState ? (
          <Tooltip tooltip={label} placement="right" disable={false}>
            {externalNavItem}
          </Tooltip>
        ) : (
          externalNavItem
        )}
      </a>
    );
  }

  // For contract-related child apps (frame_agreement, esign, agreement_template)
  // navigate to the contract root and include a query param to indicate which tab should be selected.
  const CONTRACT_CHILD_APPS = ['frame_agreement', 'esign', 'agreement_template'];
  // For marketplace-related child apps (quotations)
  const MARKETPLACE_CHILD_APPS = ['quotations'];
  // For order-related child apps (merchant_orders, marketplace_orders, common_orders)
  // navigate to the orders root and include a query param to indicate which tab should be selected.
  const ORDER_CHILD_APPS = ['merchant_orders', 'marketplace_orders', 'common_orders', 'orders'];
  // For product-related child apps (nokia_products, merchant_products, common_products)
  // navigate to the products root. Do NOT include a query param for products—tabs
  // will be handled within the products page itself to avoid extra `?tab=` in URLs.
  const PRODUCT_CHILD_APPS = ['nokia_products', 'merchant_products', 'common_products', 'products'];
  // Determine base route for navItem and build route object with optional ?tab parameter
  let route = getRouteForNavItem(navItem);
  if (CONTRACT_CHILD_APPS.includes(navItem)) route = 'contract';
  else if (ORDER_CHILD_APPS.includes(navItem)) route = 'orders';
  else if (PRODUCT_CHILD_APPS.includes(navItem)) route = 'products';

  // Map generic/common nav keys to a more specific tab identifier used by the target page
  let tabParam = navItem;
  if (navItem === 'common_products') tabParam = 'nokia_products';
  if (navItem === 'common_orders') tabParam = 'marketplace_orders';

  // Only include the `?tab=` search param for contract-related child apps.
  // Order and product child apps should navigate to their route without query params.
  const routeObj: any = (CONTRACT_CHILD_APPS.includes(navItem))
    ? { pathname: `/${route}`, search: `?tab=${tabParam}` }
    : `/${route}`;
  // Compute clickable path (include search when contract child app)
  const pathWithSearch = typeof routeObj === 'string' ? routeObj : `${routeObj.pathname}${routeObj.search || ''}`;

  const isActive = location.pathname === `/${route}` || location.pathname.startsWith(`/${route}/`);

  const handleClickNav = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    handleTabCommonPropsReset();
    // Ensure sidebar remains open when navigating
    dispatch(setProp({ slice: 'common', key: 'sideBarOpen', value: true }));
    // Pass tab info via navigation state for order/product child apps so we don't rely on query params
    // For marketplace child apps like `quotations`, navigate to /marketplace and pass tab in state
    const navState = MARKETPLACE_CHILD_APPS.includes(navItem) ? { tab: tabParam } : ((ORDER_CHILD_APPS.includes(navItem) || PRODUCT_CHILD_APPS.includes(navItem)) ? { tab: tabParam } : undefined);
    if (navState) navigate(pathWithSearch, { state: navState });
    else navigate(pathWithSearch);
  }

  const showDebug = typeof window !== 'undefined' && new URL(window.location.href).searchParams.get('debugSideNav') === 'true';
  const labelNode = showDebug ? (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span>{label}</span>
      {typeof orderIndex === 'number' && <span style={{ background: '#eee', color: '#333', padding: '2px 6px', borderRadius: 8, fontSize: 11 }}>{orderIndex}</span>}
    </span>
  ) : label;

  // Helper to render either a string src or an Icon component
  const rawIcon = getIcon(navItem);
  const renderIcon = () => {
    if (!rawIcon) return null;
    if (typeof rawIcon === 'string') return <img className="sd-item-icon" alt={`Icon ${route}`} src={rawIcon} />;
    if (React.isValidElement(rawIcon)) return rawIcon;
    return React.createElement(rawIcon as any, { className: 'sd-item-icon' });
  };

  if (groupItem) {
    const itemProps: any = {
      className: 'side-drawer-group-child',
      icon: renderIcon(),
      label: labelNode,
      selected: isActive,
      // expose render index for debugging
      'data-order': typeof orderIndex === 'number' ? orderIndex : undefined,
      badge: navItemOrProps?.badge,
      onClick: handleClickNav,
      onKeyDown: (e) => { if (e.key === 'Enter') handleClickNav(e); },
      role: 'button',
      tabIndex: 0,
    };

    return (
      !sidBarToggleState ? (
        <Tooltip tooltip={label} placement="right" disable={false}>
          <SideDrawerItem {...itemProps} />
        </Tooltip>
      ) : (
        <SideDrawerItem {...itemProps} />
      )
    );
  }

  return (
    !sidBarToggleState ? (
      <Tooltip tooltip={label} placement="right" disable={false}>
        <SideDrawerItem
          icon={renderIcon()}
          label={labelNode}
          selected={isActive}
          onClick={handleClickNav}
          onKeyDown={(e) => { if (e.key === 'Enter') handleClickNav(e); }}
          role="button"
          tabIndex={0}
        />
      </Tooltip>
    ) : (
      <SideDrawerItem
        icon={renderIcon()}
        label={label}
        selected={isActive}
        onClick={handleClickNav}
        onKeyDown={(e) => { if (e.key === 'Enter') handleClickNav(e); }}
        role="button"
        tabIndex={0}
      />
    )
  );
};

export default LoadNavLinks;
